import React from "react"

import { Trans } from "gatsby-plugin-react-i18next"

import * as bylineStyles from "../styles/Byline.module.css"

const permissionGranted = auhorName => {
  let granted = false

  switch (auhorName) {
    case `Robin Stevens`:
      granted = true
      break
    case `Joseph Pusztai`:
    default:
      granted = false
      break
  }

  return granted
}

const linkedIn = auhorName => {
  let link = null

  switch (auhorName) {
    case `Robin Stevens`:
      link = `https://www.linkedin.com/in/robinstevens2/`
      break
    case `Joseph Pusztai`:
    default:
      link = null
      break
  }

  return link
}

const about = auhorName => {
  let desc = null

  switch (auhorName) {
    case `Robin Stevens`:
      desc = `Principal Consultant`
      break
    case `Joseph Pusztai`:
    default:
      desc = null
      break
  }

  return desc
}

export default function Byline(props) {
  if (!permissionGranted(props.authorName)) return <></>

  return (
    <>
      <div className={`${bylineStyles.wrapper}`}>
        <div className={`row ${bylineStyles.heading}`}>
          <div className={`col-12`}>
            {/* <p>
              <Trans>Written by:</Trans>
            </p> */}
          </div>
        </div>
        <div className={`row ${bylineStyles.details}`}>
          <div className={`col-2`}>
            <img src={props.authorAvatar} alt={props.authorName} />
          </div>
          <div className={`col-9`}>
            <p
              className={`${bylineStyles.name}`}
              dangerouslySetInnerHTML={{ __html: props.authorName }}
            />
            <p
              className={`${bylineStyles.about}`}
              dangerouslySetInnerHTML={{ __html: about(props.authorName) }}
            />
            <span className={`${bylineStyles.connect}`}>
              Let's connect at{" "}
              <a
                href={linkedIn(props.authorName)}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>{" "}
              !
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
